import { Mail } from "lucide-react";
import signalIcon from "./assets/contact-icons/signal.svg";
import whatsappIcon from "./assets/contact-icons/whatsapp.svg";
import telegramIcon from "./assets/contact-icons/telegram.svg";

const brandIcons = { signal: signalIcon, whatsapp: whatsappIcon, telegram: telegramIcon };

/** Decorative marks; the adjacent service name provides the accessible label. */
export function HelpdeskContactIcon({ channel }: {
  channel: keyof typeof brandIcons | "email";
}) {
  return <div className={`contact-icon helpdesk-contact-icon is-${channel}`} aria-hidden="true">
    {channel === "email"
      ? <Mail className="helpdesk-contact-envelope" size={48} fill="var(--helpdesk-contact-email)" stroke="white" strokeWidth={1.4} />
      : <img src={brandIcons[channel]} alt="" width={48} height={48} draggable={false} />}
  </div>;
}
